import { ImpersonationController } from "./impersonation-controller";
import { impersonationModel } from "../../models/impersonation";

let controller = null;

export function controllerImpersonation() {
  if (!controller) {
    controller = new ImpersonationController({
      models: {
        impersonation: impersonationModel(),
      },
    });
  }

  return controller;
}
